import { Pencil } from 'lucide-react';
import { Delete20Filled, DeleteDismiss20Regular } from '@fluentui/react-icons';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import Bar from '../../../../components/elements/Bar';
import List from '../../../../components/elements/List';

const BuildingObjectDetailView = ({ onEdit, onDelete }) => {
  const permission = useSelector((state) => state.auth.pagePermission);
  const { detail } = useSelector((state) => state.buildingObject);

  const data = useMemo(() => {
    return [
      { name: 'Typ stavebního objektu', value: detail.building_object_type },
      { name: 'Název', value: detail.title },
      { name: 'Plný popis', value: detail.description },
      { name: 'Číslo', value: detail.number },
    ];
  }, [detail]);

  return (
    <div>
      <Bar
        text="Detail"
        content={
          permission === 2
            ? [
                <Pencil
                  key={1}
                  className="h-4 w-4"
                  data-testid="building-object-edit-btn"
                  onClick={onEdit}
                />,
                ...(detail.is_active
                  ? [
                      <Delete20Filled
                        key={2}
                        data-testid="building-object-delete-btn"
                        onClick={onDelete}
                      />,
                    ]
                  : [
                      <DeleteDismiss20Regular
                        key={2}
                        data-testid="building-object-restore-btn"
                        onClick={onDelete}
                      />,
                    ]),
              ]
            : []
        }
      />
      <List data={data || []} />
    </div>
  );
};

export default BuildingObjectDetailView;
